import React, { useContext } from 'react';
import HmiContext from '../../context/HmiContext';
import FormatMessage from '../../messages/FormatMessage';
import AppCard from '../AppCard/AppCard';

const HmiDataPlug: React.FC = () => {
  const hmiContext = useContext(HmiContext);
  const { parentApp, dependencyApps } = hmiContext.hmi;

  if (
    !parentApp ||
    !dependencyApps ||
    (dependencyApps && dependencyApps.length === 0)
  ) {
    return null;
  }

  return (
    <div>
      <div className={'hmi-section-title'}>
        <FormatMessage id={'hmi.plug.title'} />
      </div>
      <div className={'hmi-text-grey'}>
        <FormatMessage id={'hmi.plug.description'} />
      </div>

      {dependencyApps.map((app, index) => {
        return (
          <AppCard
            key={app.id + index}
            appId={app.id}
            appName={app.info.name}
          />
        );
      })}

      <div className={'hmi-text-grey'}>
        <FormatMessage
          id={'hmi.plug.takeActions'}
          values={{
            name: parentApp.info.name,
            plug: dependencyApps[0].info.name,
          }}
        />
      </div>
    </div>
  );
};

export default HmiDataPlug;
